import { render, staticRenderFns } from "./CheckboxCom.vue?vue&type=template&id=5ec79575&scoped=true&"
import script from "./CheckboxCom.vue?vue&type=script&lang=js&"
export * from "./CheckboxCom.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxCom.vue?vue&type=style&index=0&id=5ec79575&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec79575",
  null
  
)

export default component.exports